<span> You'll be redirected to PayPal page, where you can pay using  credit/debit card or wallet</span>
<h2 *ngIf="paypalLoad">Paypal button is loading</h2>
<div id="paypal-checkout-btn"></div> 